export default __webpack_public_path__ + "static/tooltip-interactive-1-dont-dark-34515a98e5dc5c8f79a25a0ad1e527958ae837880de359f71ac138d3335f788b.png";